import {
  CIVILOPNAME_LOADING,
  GET_CIVILOPNAME,
  GET_CIVILOPNAME_SUCCESS,
  GET_CIVILOPNAME_FAIL,
  ADD_CIVILOPNAME_SUCCESS,
  ADD_CIVILOPNAME_FAIL,
  DELETE_CIVILOPNAME_SUCCESS,
  DELETE_CIVILOPNAME_FAIL,
  UPDATE_CIVILOPNAME_SUCCESS,
  UPDATE_CIVILOPNAME_FAIL,
  CIVILOPNAME_RESET
} from "./actionType";

const INIT_STATE = {
  civilOpnames: [],
  error: {},
};

const CivilOpname = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILOPNAME_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILOPNAME:
          return {
            ...state,
            civilOpnames: action.payload.data,
            isCivilOpnameCreated: false,
            isCivilOpnameSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILOPNAME_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILOPNAME_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilOpnameCreated: false,
            isCivilOpnameSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILOPNAME: {
      return {
        ...state,
        isCivilOpnameCreated: false,
        loading: true,
      };
    }

    case CIVILOPNAME_LOADING: {
      return {
        ...state,
        isCivilOpnameCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILOPNAME_SUCCESS:
      return {
        ...state,
        isCivilOpnameCreated: true,
        loading: false,
        civilOpnames: [action.payload.data, ...state.civilOpnames],
      };

    case ADD_CIVILOPNAME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILOPNAME_SUCCESS:
      return {
        ...state,
        loading: false,
        civilOpnames: state.civilOpnames.filter(
          civilCivilOpname => civilCivilOpname.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILOPNAME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILOPNAME_SUCCESS:
      return {
        ...state,
        loading: false,
        civilOpnames: state.civilOpnames.map(civilCivilOpname =>
          civilCivilOpname.id.toString() === action.payload.data.id.toString() ? { ...civilCivilOpname, ...action.payload.data } : civilCivilOpname
        ),
      };

    case UPDATE_CIVILOPNAME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILOPNAME_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilOpname;